import React, { FC, PropsWithChildren, useState, useRef, Children, isValidElement, cloneElement } from 'react';
import { showToast as taroShowToast } from '@tarojs/taro';
import { ScrollView } from '@tarojs/components';
import classNames from 'classnames';
import View from '../view';
import List from './List';
import { uuid } from '../../common/utils';

interface IIndexesProps {
  className?: string;
  indexList?: string[];
}

const showToast = (message: string) => {
  taroShowToast({
    icon: 'none',
    title: message,
    mask: false,
    duration: 1500,
  });
};

const Indexes: FC<PropsWithChildren<IIndexesProps>> & { List: typeof List } = ({ className = '', children, indexList = [] }) => {
  const scrollIdPrefixRef = useRef(`Ink-indexes-${uuid()}`);
  const [scrollViewId, setScrollViewId] = useState('');
  const rootClass = classNames('ink-indexes', className);
  return (
    <View className={rootClass}>
      <View className="ink-indexes__nav">
        {indexList.map((index) => (
          <View
            key={index}
            className="ink-indexes__index"
            onClick={() => {
              showToast(index);
              setScrollViewId(`${scrollIdPrefixRef.current}-${index}`);
            }}
          >
            {index}
          </View>
        ))}
      </View>
      <ScrollView className="ink-indexes__body" scrollWithAnimation scrollY scrollIntoView={scrollViewId}>
        {Children.map(children, (node) => (isValidElement(node) ? cloneElement(node, { index: node.key, id: `${scrollIdPrefixRef.current}-${node.key}` }) : node))}
      </ScrollView>
    </View>
  );
};

Indexes.List = List;

export default Indexes;
